"use client";

import React, { FC, useEffect, useRef } from "react";

declare global {
  interface Window {
    __VM: any[];
  }
}

type ProsperAdProps = {
  placementName: string;
  alias?: string;
  className?: string;
};

const ProsperAd: FC<ProsperAdProps> = ({ placementName, alias, className }) => {
  const elRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let placement: any;
    console.log(
      "[PROSPER] add",
      placementName,
      alias ? `(alias: ${alias})` : "",
    );

    // Initialize __VM if it doesn't exist
    if (typeof window !== "undefined") {
      window.__VM = window.__VM || [];

      window.__VM.push(function (admanager: any, scope: any) {
        try {
          if (placementName === "vertical_sticky") {
            placement = scope.Config.verticalSticky().display();
          } else if (
            placementName === "horizontal_sticky" ||
            placementName === "mobile_horizontal_sticky" ||
            placementName === "video_slider"
          ) {
            placement = scope.Config.get(placementName).displayBody();
          } else {
            const config = scope.Config.get(placementName);
            if (alias) {
              placement = config.display(elRef.current, { alias });
            } else {
              placement = config.display(elRef.current);
            }
          }
        } catch (error) {
          console.error(
            "[PROSPER] Error adding placement:",
            placementName,
            error,
          );
        }
      });
    }

    return () => {
      if (typeof window !== "undefined") {
        window.__VM = window.__VM || [];

        window.__VM.push(function (admanager: any, scope: any) {
          try {
            console.log("[PROSPER] removed", placementName);
            if (placementName === "vertical_sticky") {
              scope.Config.verticalSticky().destroy();
            } else if (placement) {
              placement.remove();
            }
          } catch (error) {
            console.error(
              "[PROSPER] Error removing placement:",
              placementName,
              error,
            );
          }
        });
      }
    };
  }, [placementName, alias]);

  // Don't render a div for sticky and body-injected placements
  if (
    placementName === "vertical_sticky" ||
    placementName === "horizontal_sticky" ||
    placementName === "mobile_horizontal_sticky" ||
    placementName === "video_slider"
  ) {
    return null;
  }

  return <div ref={elRef} className={className}></div>;
};

export default ProsperAd;
